import React, { useCallback, useEffect, useState } from 'react';
import { FaCheck, FaPencil, FaXmark } from "react-icons/fa6";
import { useOutsideClick } from "./utils";

interface Props {
    editable: boolean;
    value: number;
    setValue: (value: number) => void;
    onClose: () => void;
}

function EditableNumberInput(props: Props) {
    const [value, setValue] = useState(props.value);

    useEffect(() => setValue(props.value), [props.value]);

    const onCancel = useCallback(() => {
        props.onClose();
        setValue(props.value);
    }, [props.value]);

    const onConfirm = () => {
        props.onClose();
        props.setValue(value);
    };

    const ref = useOutsideClick(onCancel);

    if (!props.editable) {
        return (
            <div className="editable-field">
               <div>{value}</div>
            </div>
        );
    }

    return (
        <div ref={ref} className="editable-input-field">
            <input
                style={{width: '60px'}}
                type="number"
                value={value}
                onChange={(e) => setValue(Number(e.target.value))}
            />
            <FaCheck className="icon" size="24px" onClick={onConfirm} />
            <FaXmark className="icon" size="24px" onClick={onCancel} />
        </div>
    );
}

export default EditableNumberInput;
